import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7fc39e6c")

_pushScopeId("data-v-7fc39e6c")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center text-white" }
const _hoisted_3 = { class: "col-lg-8 col-md-8 col-sm-12 login-form " }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "ml-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("button", { class: "btn btn-link" }, [
  /*#__PURE__*/_createVNode("svg", {
    style: {"width":"24px","height":"24px"},
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "currentColor",
      d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-2" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "img-fluid",
      alt: "Responsive image"
    })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("h2", null, "Satstreet"),
    /*#__PURE__*/_createVNode("p", null, "Terms of service")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, " * Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, deserunt iusto ducimus numquam mollitia ut, accusamus dolor dolorem aliquam placeat culpa ipsa ab vitae libero expedita in quae voluptate sunt! ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, " * Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, deserunt iusto ducimus numquam mollitia ut, accusamus dolor dolorem aliquam placeat culpa ipsa ab vitae libero expedita in quae voluptate sunt! ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, " * Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, deserunt iusto ducimus numquam mollitia ut, accusamus dolor dolorem aliquam placeat culpa ipsa ab vitae libero expedita in quae voluptate sunt! ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, " * Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, deserunt iusto ducimus numquam mollitia ut, accusamus dolor dolorem aliquam placeat culpa ipsa ab vitae libero expedita in quae voluptate sunt! ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Satstreet © ")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", null, "2020", -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col justify-content-md-center" }
const _hoisted_22 = /*#__PURE__*/_createVNode("button", { class: "btn btn-primary" }, " Go back ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_router_link, { to: { name: 'auth.register' } }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _hoisted_19
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_router_link, { to: { name: 'auth.register' } }, {
          default: _withId(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
})